import {useI18n} from 'vue-i18n';
import {computed, type ComputedRef} from 'vue';
import type {Language} from '@/ts/types/component/localization.type';
import {persistentStorage} from '@/ts/instances/persistant-storage';
import {analyticsService} from '@/ts/services/analytics-service';

// Re-export from browser-language.ts (single source of truth)
export {SUPPORTED_LANGUAGES} from '@/ts/utils/browser-language';

/** Provides the current language as a computed ref and a setter that persists the choice and updates analytics */
export function useLang(): {
  lang: ComputedRef<Language>,
  setLanguage(lang: Language): void,
} {
  const i18n = useI18n();
  const lang = computed<Language>(() => i18n.locale.value as Language);

  function setLanguage(newVal: Language): void {
    persistentStorage.language = newVal;
    i18n.locale.value = newVal;
    analyticsService.setLanguage(newVal);
  }

  return {
    lang, setLanguage,
  };
}
